// import { useRouter } from 'next/router';
import { cn } from 'common/utils';
import {
  colorByValue,
  formatCurrency,
  formatPercent,
} from 'common/utils/trading-demo';
import {
  PortfolioTransactionType,
  PositionTypeEnum,
} from 'service/trading-demo';

interface SettledPositionItemPropsType {
  position: PortfolioTransactionType;
  className?: string;
}

const SettledPositionItem = ({
  position,
  className,
}: SettledPositionItemPropsType): JSX.Element => {
  // const router = useRouter();
  return (
    <div
      className={cn(
        'border-b border-gray-200 px-2 py-3 pb-4 last:border-b-0 md:px-5 md:py-4',
        className,
      )}
    >
      {/* <div className="mb-2 flex items-center text-xs font-semibold tracking-wide text-pp-text-secondary">
        {dayjs(position.closed_at).format('MM月DD日')} {'→ 保有'}
        {position.holding_duration}日
      </div> */}
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <div
            className={cn(
              'flex size-6 shrink-0 items-center justify-center rounded text-xs font-bold',
              position.position_type === PositionTypeEnum.Long
                ? 'bg-pp-green-subtle text-growth-green'
                : 'bg-[#ef444426] text-pp-error-primary',
            )}
          >
            {position.position_type === PositionTypeEnum.Long ? '買' : '売'}
          </div>
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="font-semibold text-pp-text-primary">
                {position.symbol_name}
              </span>
              <span className="text-xs text-pp-text-secondary">
                数量：{position.quantity}
              </span>
            </div>
            {/* {position.position_post &&
              position.position_post.user_name &&
              position.position_post.post_id && (
                <button
                  className="mt-0.5 flex items-center gap-1.5 text-xs text-pp-text-secondary transition-colors hover:text-pp-text-primary"
                  onClick={() => {
                    void router.push(
                      `/${position.position_post.user_name}/posts/${position.position_post.post_id}`,
                    );
                  }}
                >
                  <img
                    src={
                      position.position_post?.user_avatar || DEFAULT_AVATAR_URL
                    }
                    alt={position.position_post.name}
                    className="size-4 rounded-full"
                  />
                  <span className="line-clamp-1 md:line-clamp-none">
                    {position.position_post.name}
                  </span>
                </button>
              )} */}
            <div className="mt-0.5 flex flex-col gap-1 text-xs text-pp-text-secondary">
              <div className="flex items-center gap-1">
                <span>取得価格:</span>
                <span>
                  {formatCurrency({
                    value: position.entry_price,
                    supportZero: false,
                    withSign: false,
                    currency: position.symbol_currency || '',
                  })}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <span>決済価格:</span>
                <span>
                  {formatCurrency({
                    value: position.exit_price,
                    supportZero: false,
                    withSign: false,
                    currency: position.symbol_currency || '',
                  })}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="min-w-[110px] text-right">
          <div
            className={cn(
              'font-semibold',
              colorByValue(
                parseFloat(position.realized_pnl),
                'text-pp-text-primary',
              ),
            )}
          >
            {formatCurrency({
              value: position.realized_pnl,
              supportZero: true,
              withSign: true,
              currency: 'JPY',
            })}
          </div>
          <div
            className={cn(
              'mt-0.5 text-xs',
              colorByValue(
                parseFloat(position.realized_pnl),
                'text-pp-text-secondary',
              ),
            )}
          >
            (
            {formatPercent({
              value: position.realized_pnl_pct,
              supportZero: true,
              withSign: true,
            })}
            )
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettledPositionItem;
